import React from 'react';
import { Link } from 'react-router-dom';

/**
 * MobileOnlyGate Component
 * Shows a message on desktop that the page is only available on mobile devices
 */
const MobileOnlyGate = ({ type = 'login' }) => {
  const isSignUp = type === 'signup';
  const isApp = type === 'app';

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background text decorations */}
      <div style={{
        position: 'absolute',
        inset: 0,
        overflow: 'hidden',
        opacity: 0.1,
        pointerEvents: 'none'
      }}>
        <span style={{ position: 'absolute', top: '10%', left: '5%', fontSize: '4rem', fontWeight: '900', color: '#fff' }}>Nasdaq</span>
        <span style={{ position: 'absolute', top: '25%', left: '15%', fontSize: '3rem', fontWeight: '900', color: '#fff' }}>ETFs</span>
        <span style={{ position: 'absolute', top: '40%', left: '3%', fontSize: '2.5rem', fontWeight: '900', color: '#fff' }}>Volatility</span>
        <span style={{ position: 'absolute', top: '55%', left: '10%', fontSize: '3.5rem', fontWeight: '900', color: '#fff' }}>Rates</span>
        <span style={{ position: 'absolute', top: '70%', left: '2%', fontSize: '2rem', fontWeight: '900', color: '#fff' }}>investing</span>
        <span style={{ position: 'absolute', top: '15%', right: '5%', fontSize: '3rem', fontWeight: '900', color: '#fff' }}>Stocks</span>
        <span style={{ position: 'absolute', top: '35%', right: '8%', fontSize: '2.5rem', fontWeight: '900', color: '#fff' }}>Rates</span>
        <span style={{ position: 'absolute', top: '50%', right: '3%', fontSize: '4rem', fontWeight: '900', color: '#fff' }}>Bonds</span>
        <span style={{ position: 'absolute', top: '65%', right: '10%', fontSize: '2rem', fontWeight: '900', color: '#fff' }}>Trading</span>
      </div>

      {/* Main content card */}
      <div style={{
        background: 'rgba(30, 41, 59, 0.95)',
        borderRadius: '16px',
        padding: '48px 40px',
        maxWidth: '480px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        position: 'relative',
        zIndex: 10
      }}>
        {/* Mobile icon */}
        <div style={{
          fontSize: '48px',
          marginBottom: '24px'
        }}>
          📱
        </div>

        {/* Title */}
        <h1 style={{
          color: '#FFFFFF',
          fontSize: '2.5rem',
          fontWeight: '900',
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          marginBottom: '24px',
          lineHeight: '1.2'
        }}>
          MOBILE<br />BROWSER<br />REQUIRED
        </h1>

        {/* Description */}
        <p style={{
          color: 'rgba(255, 255, 255, 0.8)',
          fontSize: '1.1rem',
          lineHeight: '1.6',
          marginBottom: '32px'
        }}>
          {isApp
            ? 'ArrowApp is available on mobile devices only.'
            : isSignUp
              ? 'Sign up is currently available on mobile devices only.'
              : 'Login is currently available on mobile devices only.'
          }
          <br />
          Please open this page on your smartphone or tablet{isApp ? '' : ` to ${isSignUp ? 'create an account' : 'sign in'}`}.
        </p>

        {/* How to access box */}
        <div style={{
          background: 'rgba(255, 255, 255, 0.05)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '12px',
          padding: '24px',
          marginBottom: '32px'
        }}>
          <h3 style={{
            color: '#FFFFFF',
            fontSize: '0.9rem',
            fontWeight: '700',
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            marginBottom: '16px'
          }}>
            HOW TO ACCESS:
          </h3>
          <ol style={{
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: '0.95rem',
            lineHeight: '1.8',
            textAlign: 'left',
            paddingLeft: '20px',
            margin: 0
          }}>
            <li>Open your mobile browser (Safari, Chrome, etc.)</li>
            <li>Visit this same URL on your phone</li>
            <li>{isApp ? 'Pick up right where you left off' : isSignUp ? 'Create your account and start trading' : 'Sign in with your credentials'}</li>
          </ol>
        </div>

        {/* Alternative action */}
        {!isApp && (
        <>
        <div style={{
          color: 'rgba(255, 255, 255, 0.7)',
          fontSize: '1rem',
          marginBottom: '16px'
        }}>
          {isSignUp ? 'Already have an account?' : 'New to the app?'}
        </div>

        <Link
          to={isSignUp ? '/login' : '/signup'}
          style={{
            display: 'inline-block',
            padding: '14px 32px',
            background: 'transparent',
            color: '#60a5fa',
            border: '2px solid #60a5fa',
            borderRadius: '8px',
            fontSize: '1rem',
            fontWeight: '600',
            textDecoration: 'none',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = '#60a5fa';
            e.target.style.color = '#1a1a2e';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'transparent';
            e.target.style.color = '#60a5fa';
          }}
        >
          {isSignUp ? 'Sign In' : 'Create Account'}
        </Link>

        {/* Terms */}
        <p style={{
          color: 'rgba(255, 255, 255, 0.5)',
          fontSize: '0.8rem',
          marginTop: '24px'
        }}>
          By {isSignUp ? 'signing up' : 'signing in'}, you agree to our{' '}
          <Link to="/terms" style={{ color: '#60a5fa', textDecoration: 'none' }}>Terms & Conditions</Link>
          {' '}and{' '}
          <Link to="/privacy" style={{ color: '#60a5fa', textDecoration: 'none' }}>Privacy Policy</Link>
        </p>
        </>
        )}
      </div>
    </div>
  );
};

export default MobileOnlyGate;
